import { useTranslation } from "react-i18next"
import { Check } from "@phosphor-icons/react"
import { Chip } from "@/components/ui/chip"
import { cn } from "@/lib/utils"

type PotentialDuplicatesToggleProps = React.ComponentPropsWithoutRef<typeof Chip>

const PotentialDuplicatesToggle = ({ ...props }: PotentialDuplicatesToggleProps) => {
  const { t } = useTranslation()

  return (
    <Chip
      {...props}
      data-testid="potential-duplicates-filter-button"
      data-state={props.checked && "checked"}
      className={cn("h-8")}>
      <div className="flex items-center gap-0.5">
        <Check className={cn("overflow-hidden transition-all duration-200", props.checked ? "w-5" : "w-0")} size={20} />
        <div className="truncate px-1.5">{t("patient.list.potentialDuplicatesLabel")}</div>
      </div>
    </Chip>
  )
}

export { PotentialDuplicatesToggle }
